import React from 'react';
import DisplayField from '../../../../../itrust_common/components/others/DisplayField'
import OldValuesHeader from '../../oldValues/OldValuesHeader';

let Nct = props => {
  const { template, previousExams, overviewName, examId } = props;
  return (
    <>
      {previousExams?.filter(item => item.id !== examId).map(prevExam =>
        <div className="col-12 border rounded mb-4 px-0">
          <div className="row mx-0">
            <OldValuesHeader prevExam={prevExam} overviewName={overviewName} examId={examId} />
            {prevExam?.nct && prevExam.nct.map(item =>
              item.is_marked_complete && <div className="col-12 py-4">
                <div className="overview-table mb-3">
                  <table className="table table-bordered bg-light table-hover shadow-none border border-muted">
                    <tbody>
                      {["od", "os", "time"].map(type =>
                        <tr className="text-center">
                          <td>
                            <h6>{type.toUpperCase()}</h6>
                          </td>
                          <td>
                            <DisplayField
                              isVisible={template.ncts[0].fields[type].visible}
                              value={type !== "time" ? item[type] : item[`nct_${type}`]}
                            />
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  )
}
export default Nct;